/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, Box } from "@mui/system";

const getColorCode = (status) => {
  switch (status) {
    case 'active':
      return '#39cd80'
    case 'draft':
      return '#61b2fa'
    case 'archived':
      return '#f64246'
    default:
      return '#9e9e9e'
  }
}

export const StatusContainer = styled(Box)(({ status }) => ({
  height: "22px",
  width: "100px",
  borderRadius: "6px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: `${getColorCode(status)}20`,
  color: getColorCode(status),
  fontSize: '0.775rem',
  padding: '2px',
}));
